import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { A11yModule } from '@angular/cdk/a11y';
import { StartTestDialogComponent } from './start-test-dialog.component';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		A11yModule,
		GoDialogContentDirective
	],
	declarations: [
		StartTestDialogComponent
	],
	exports: [
		StartTestDialogComponent
	],
	providers: [
		TranslatePipe
	]
})
export class StartTestDialogModule {}
